import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Occurrences' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    container: {
        display: 'inline-flex',
        padding: 4,
        alignItems: 'center',
        gap: 4,
        borderRadius: 20,
        background: '#F8F8F8',
        flexWrap: 'wrap',
        width: 'max-content',
        maxWidth: '100%'
    },
    item: {
        display: 'inline-flex',
        padding: '8px 12px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 96,
        background: '#FFF',
        gap: 8,
        whiteSpace: 'nowrap',
        transition: 'background 0.2s',
        cursor: 'pointer',
        textDecoration: 'none',
        ['&:hover']: {
            background: '#F8F8F8'
        }
    },
    label: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    count: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    }
});
